// Enums Derived From Spec Types (require manual check for changes)
export var ETransactionType;
(function (ETransactionType) {
    ETransactionType["DECLARE"] = "DECLARE";
    ETransactionType["DEPLOY"] = "DEPLOY";
    ETransactionType["DEPLOY_ACCOUNT"] = "DEPLOY_ACCOUNT";
    ETransactionType["INVOKE"] = "INVOKE";
    ETransactionType["L1_HANDLER"] = "L1_HANDLER";
})(ETransactionType || (ETransactionType = {}));
export var ESimulationFlag;
(function (ESimulationFlag) {
    ESimulationFlag["SKIP_VALIDATE"] = "SKIP_VALIDATE";
    ESimulationFlag["SKIP_FEE_CHARGE"] = "SKIP_FEE_CHARGE";
})(ESimulationFlag || (ESimulationFlag = {}));
export var ETransactionStatus;
(function (ETransactionStatus) {
    ETransactionStatus["RECEIVED"] = "RECEIVED";
    ETransactionStatus["REJECTED"] = "REJECTED";
    ETransactionStatus["ACCEPTED_ON_L2"] = "ACCEPTED_ON_L2";
    ETransactionStatus["ACCEPTED_ON_L1"] = "ACCEPTED_ON_L1";
})(ETransactionStatus || (ETransactionStatus = {}));
export var ETransactionFinalityStatus;
(function (ETransactionFinalityStatus) {
    ETransactionFinalityStatus["ACCEPTED_ON_L2"] = "ACCEPTED_ON_L2";
    ETransactionFinalityStatus["ACCEPTED_ON_L1"] = "ACCEPTED_ON_L1";
})(ETransactionFinalityStatus || (ETransactionFinalityStatus = {}));
export var ETransactionExecutionStatus;
(function (ETransactionExecutionStatus) {
    ETransactionExecutionStatus["SUCCEEDED"] = "SUCCEEDED";
    ETransactionExecutionStatus["REVERTED"] = "REVERTED";
})(ETransactionExecutionStatus || (ETransactionExecutionStatus = {}));
export var EBlockTag;
(function (EBlockTag) {
    EBlockTag["LATEST"] = "latest";
    EBlockTag["PENDING"] = "pending";
})(EBlockTag || (EBlockTag = {}));
// 'L1' | 'L2'
export var EDataAvailabilityMode;
(function (EDataAvailabilityMode) {
    EDataAvailabilityMode["L1"] = "L1";
    EDataAvailabilityMode["L2"] = "L2";
})(EDataAvailabilityMode || (EDataAvailabilityMode = {}));
// 0 | 1
export var EDAMode;
(function (EDAMode) {
    EDAMode[EDAMode["L1"] = 0] = "L1";
    EDAMode[EDAMode["L2"] = 1] = "L2";
})(EDAMode || (EDAMode = {}));
/**
 * V_ Transaction versions HexString
 * F_ Fee Transaction Versions HexString (2 ** 128 + TRANSACTION_VERSION)
 */
export var ETransactionVersion;
(function (ETransactionVersion) {
    ETransactionVersion["V0"] = "0x0";
    ETransactionVersion["V1"] = "0x1";
    ETransactionVersion["V2"] = "0x2";
    ETransactionVersion["V3"] = "0x3";
    ETransactionVersion["F0"] = "0x100000000000000000000000000000000";
    ETransactionVersion["F1"] = "0x100000000000000000000000000000001";
    ETransactionVersion["F2"] = "0x100000000000000000000000000000002";
    ETransactionVersion["F3"] = "0x100000000000000000000000000000003";
})(ETransactionVersion || (ETransactionVersion = {}));
/**
 * Old Transaction Versions
 */
export var ETransactionVersion2;
(function (ETransactionVersion2) {
    ETransactionVersion2["V0"] = "0x0";
    ETransactionVersion2["V1"] = "0x1";
    ETransactionVersion2["V2"] = "0x2";
    ETransactionVersion2["F0"] = "0x100000000000000000000000000000000";
    ETransactionVersion2["F1"] = "0x100000000000000000000000000000001";
    ETransactionVersion2["F2"] = "0x100000000000000000000000000000002";
})(ETransactionVersion2 || (ETransactionVersion2 = {}));
/**
 * V3 Transaction Versions
 */
export var ETransactionVersion3;
(function (ETransactionVersion3) {
    ETransactionVersion3["V3"] = "0x3";
    ETransactionVersion3["F3"] = "0x100000000000000000000000000000003";
})(ETransactionVersion3 || (ETransactionVersion3 = {}));
//# sourceMappingURL=nonspec.js.map